// extracted by mini-css-extract-plugin
module.exports = {"truncatedCell":"MyData_truncatedCell__37fgS","headerColumnText":"MyData_headerColumnText__1Eamg","shareButton":"MyData_shareButton__1SLUu","name":"MyData_name__6SRov"};